import React from 'react';
import OrdersTab from '../components/wms/OrdersTab';

const WMSOrdersPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl lg:text-4xl font-bold text-slate-900">Comenzi Furnizori - WMS</h1>
        <p className="text-slate-600 mt-1">Sugestii aprovizionare si gestionare comenzi</p>
      </div>
      <OrdersTab />
    </div>
  );
};

export default WMSOrdersPage;